// AWSBillingDashboard.js - Wrapper dengan token dan onDataChange ke AI
import React, { useEffect, useRef } from 'react';
import { useDashboardData } from '../context/DashboardDataContext';
import { useActiveDashboard } from '../context/ActiveDashboardContext';
import AWSDashboard from '../dashboards/AWSDashboard';

//const API_BASE = (process.env.REACT_APP_API_URL || 'http://10.32.18.160:5000') + '/api/billing';
const API_BASE = (process.env.REACT_APP_API_URL || '') + '/api/billing';

export default function AWSBillingDashboard() {
  const { publishData } = useDashboardData();
  const activeKey       = useActiveDashboard();
  const lastData        = useRef(null);

  // Re-publish saat aktif kembali
  useEffect(() => {
    if (activeKey === 'aws_billing' && lastData.current) {
      publishData(lastData.current);
    }
  }, [activeKey]); // eslint-disable-line

  const handleDataChange = (data) => {
    if (!data || !data.allData?.length) return;
    const payload = { type: 'aws_billing', ...data, updatedAt: new Date().toISOString() };
    lastData.current = payload;
    publishData(payload);
  };

  return (
    <AWSDashboard
      apiBase={API_BASE}
      onDataChange={handleDataChange}
    />
  );
}
